import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../store/common/common_action';
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import UserRollRightsTable from './UserRollRightsTable'
import { getUserRollRightTableData } from "../../../../store/branchAndUserMaster/BUMAction"

const UserRollRights = (props) => {
    const { data, updateAlertError, getUserRollRightTableData,loginData } = props
    const { common, branchAndUserMasterReducer } = data
    const { userRollRightTableData } = branchAndUserMasterReducer
    const [showTable, setShowTable] = useState(false)
    const [status, setStatus] = useState({ name: "Show All", id: -1 })
    const [catagoryData, setCatagoryData] = useState([])
    const [selCatagoryData, setSelCatagoryData] = useState("")
    const statusOpt = [{ name: "Show All", id: -1 }, { name: "Active", id: 1 }, { name: "InActive", id: 0 }]
    const [searchData, setSearchData] = useState({
        RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "",
    })
    useEffect(() => {
        focusElemnt("URRCatagory")
    }, [])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            const body = {
                CompanyID: loginData?.intCompanyID,
                RoleID: 0,
                IsActive: -1
            }
            getUserRollRightTableData(body)
        }
    }, [loginData?.intCompanyID])
    useEffect(() => {
        if (userRollRightTableData?.Table?.length > 0) {
            if (selCatagoryData == "") {
                setSelCatagoryData({ RoleID: 0, RoleName: "All" })
                setCatagoryData([{ RoleID: 0, RoleName: "All" }, ...userRollRightTableData?.Table])
                setShowTable(true)
            }
        }
    }, [userRollRightTableData])

    const onLoad = () => {
        if (selCatagoryData !== "") {
            const body = {
                CompanyID: loginData?.intCompanyID,
                RoleID: selCatagoryData?.RoleID,
                IsActive: status?.id
            }
            getUserRollRightTableData(body)
            setShowTable(true)
            setSearchData({ RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "", })
        } else {
            updateAlertError({ show: true, msg: "Select Catagory Name", nextId: "URRCatagory" })
        }
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='itemButtons'>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"URRCatagory"}
                        defaultvalue={selCatagoryData?.RoleName || ""}
                        data={catagoryData || []}
                        width="100%"
                        searchPlaceholder={`Search Category Name`}
                        label={"Category Name"}
                        dataKey={`RoleName`}
                        idKey={`RoleID`}
                        nextId={"URRStatus"}
                        prevId={"URRSave"}
                        onSelect={(value) => setSelCatagoryData(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"URRStatus"}
                        defaultvalue={status?.name || ""}
                        data={statusOpt || []}
                        width="100%"
                        searchPlaceholder={`Search Status`}
                        label={"Status"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"URRLoad"}
                        prevId={"URRCatagory"}
                        onSelect={(value) => setStatus(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, showTable ? "Contains-2" : "URRCatagory", "URRStatus", () => { })}>
                    <Button id="URRLoad" variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={onLoad}
                    >
                        LOAD
                    </Button>
                </Item>
            </Box>
            <Box sx={sx.reportFlex}>
                {(showTable) && <UserRollRightsTable tableData={userRollRightTableData?.Table || []} onLoad={onLoad} searchData={searchData} setSearchData={setSearchData} loginData={loginData} />}
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, getUserRollRightTableData
}
export default connect(mapStateToProps, mapDispatchToProps)(UserRollRights)
